import { Component, OnInit } from '@angular/core';
import { UserAuthService } from '../UserAuth.service';
import { Router } from '@angular/router';
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL,
} from '../support-contact';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
  userAccount: any = null;
  userName: string = '';
  userEmail: string = '';

  /** Support contact for the secondary line — see the note in the template. */
  readonly supportEmail = SUPPORT_EMAIL;
  readonly supportPhone = SUPPORT_PHONE;
  readonly supportPhoneTel = SUPPORT_PHONE_TEL;

  constructor(
    private authService: UserAuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Get the current user account information
    this.authService.activeAccount$.subscribe((account) => {
      if (account) {
        this.userAccount = account;
        this.userName = account.name || account.username || 'Unknown User';
        this.userEmail = account.username || 'No email available';
      }
    });
  }

  onLogout(): void {
    console.log('Logging out user');
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
